export default __webpack_public_path__ + "static/wrap-a8a09e18c1398ddd14de80a26836e7c5.gif";